/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from "styled-components";

import { FontWeight, Text } from "../Text";
import globalStyles from "globalStyles";
const { menu } = globalStyles.components;

export const Item = styled(Text)`
  color: ${menu.inactiveItem};
  font-weight: ${FontWeight.Bold};
  align-items: center;
  padding-left: 55px;
  line-height: 50px;
  height: 45px;
  display: flex;
  cursor: pointer;
  gap: 20px;
  font-size: 16px;
  font-family: Quicksand;
}
  
  i {
    color: ${menu.title};
    font-size: 27px;
  }
`;
